"use client"

import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Image } from "antd"
import { FC, useState } from "react"

type DestinationLocationThumbProps = {
  imageUrl?: string
  icon: IconDefinition
}

const DestinationLocationThumb: FC<DestinationLocationThumbProps> = ({ imageUrl, icon }) => {
  const [imageFailed, setImageFailed] = useState(false)
  const showImage = Boolean(imageUrl) && !imageFailed

  return (
    <span
      className={`home__searching--destination-thumb${showImage ? "" : " home__searching--destination-thumb--fallback"}`}
    >
      {showImage ? (
        <Image
          src={imageUrl}
          alt=""
          width="100%"
          height="100%"
          style={{ objectFit: "cover", display: "block" }}
          preview={false}
          onError={() => setImageFailed(true)}
        />
      ) : (
        <FontAwesomeIcon icon={icon} aria-hidden />
      )}
    </span>
  )
}

export default DestinationLocationThumb
